//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/index'

import PublicService from '@/service/public'

import TopFilter from '@/components/buildings_top_filter/index'
import Search from '../_search'

import HouseItem from '@/components/business/house_item'

import PageTopFilter from '@/common/mixins/page_top_filter'
import Pagination from '@/common/mixins/pagination'
import { BUILDING_STATUS } from '@/constant'
import StatusTip from '@/components/views/status_tip'

import Notice from './_notice'

const PAGE_DATA = {
    new_arrival_tips_show: false
}

export default {
    mixins: [
        PageTopFilter,
        Pagination
    ],
    data () {
        return {
            estimated_presell_times: [],
            estimated_presell_time: '',
            select_zones: [],
            position: {
                list: 'forthcoming_sale_list',
                banner: 'forthcoming_sale_top_banner'
            },
            zone_ids: '',
            zone_section_ids: '',
            area: '',
            layout: '',
            metro: '',
            keyword: '',
            interesting_order: '',
            type: '',
            recommendation: [],
            recommendation_tye: '',
            banner_loading: true,
            banner: [],
            feature: '',
            subscribed: false
        }
    },
    computed: {
        filter_tabs ()  {
            if (this.estimated_presell_times && this.estimated_presell_times.length) {
                return ['区域', '户型', '面积', '时间', 'order']
            }
            return ['区域', '户型', '面积', 'order']
        },
        show_recommendation () {
            return [
                'zone_ids',
                'zone_section_ids',
                'area',,
                'layout',
                'metro',
                'estimated_presell_time',
                'interesting_order'
            ].every(key => !this[key])
        }
    },
    created () {
        this.getData()
    },
    methods: {
        fetchData () {
            if (this.position) {
                this.recommendation_tye = this.position
                const option = {}
                this.getRecommendation()
                PublicService.getBanner(this.position.banner)
                    .then((data) => {
                        this.banner = data
                        this.banner_loading = false
                    })

                this.checkNotice()

            } else {
                this.getData()
            }
        },
        async checkNotice () {
            const data = await Service.getNoticeStatus()
            this.subscribed = data.items && data.items.some(({ msg_type, subscribed }) => {
                return msg_type === 'new_arrival_forthcoming_sale_building' && subscribed
            })
        },
        async setNotice () {
            const data = await Service.setNoticeStatus({
                notification_type: 'wxtm',
                msg_type: 'new_arrival_forthcoming_sale_building',
                subscribed: !this.subscribed
            })
            this.$wx.showToast({
                title: !this.subscribed ? '上新提醒开启' : '上新提醒关闭',
                icon: 'none'
            })
            this.subscribed = !this.subscribed
        },
        getRecommendation () {
            const position = this.recommendation_tye
            const option = {}
            if (position.list === 'forthcoming_sale_list' && this.zone_ids) {
                option.zones = this.zone_ids
            }
            PublicService.getRecommendation(position.list, option)
                .then((data) => {
                    this.recommendation = data
                    this.getData()
                })
        },
        changeFilter (filter) {
            Object.keys(filter).forEach((key) => {
                this[key] = filter[key]
            })
            this.page = 1
            this.resetList()
            this.getData()
        },
        resetList () {
            this.recommendation = []
            this.items = []
        },
        async getData () {
            this.loading = true
            const options = {
                page: this.page,
                name: this.keyword
            }
            let has_filter = false
            options.status = BUILDING_STATUS['即将预售']
            const filters = ['zone_ids', 'zone_section_ids', 'metro', 'area', 'layout', 'estimated_presell_time']
            filters.forEach((key) => {
                if (this[key]) {
                    options[key] = this[key]
                    has_filter = true
                }
            })
            if (this.interesting_order) {
                options.interesting_order = this.interesting_order
            }
            if (this.show_recommendation) {
                options.exclude_ids = this.recommendation.map(({ building_id}) => building_id).join(',')
            }
            const data = await Service.getBuildings(options)
            this.handleData(data)
            this.estimated_presell_times = data.estimated_presell_times
            if (this.page === 1 && has_filter && data.total_count) {
                this.$wx.showToast({
                    title: `共找到${data.total_count}个楼盘`,
                    icon: 'none'
                })
            } else if (!PAGE_DATA.new_arrival_tips_show && data.new_arrival_tips) {
                this.$wx.showToast({
                    title: data.new_arrival_tips,
                    icon: 'none',
                    success: () => {
                        PAGE_DATA.new_arrival_tips_show = true
                    }
                })
            }
            this.$nextTick(() => {
                if (this.page === 1) {
                    window.scrollTo(0, 0)
                }
            })
        },
        searchClick (keyword) {
            this.$router.push({
                name: 'search',
                query: {
                    type: '即将预售'
                }
            })
        }
    },
    components: {
        HouseItem,
        TopFilter,
        Search,
        Notice,
        StatusTip
    }
}
